import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/fields/$fieldId/rx/$rxId')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Outlet/>
  )
}
